// Right-to-left primary language subtags (same list as the rtl-detect package).
const RTL_LANGS = new Set([
  "ar",
  "arc",
  "dv",
  "fa",
  "ha",
  "he",
  "khw",
  "ks",
  "ku",
  "ps",
  "sd",
  "ug",
  "ur",
  "yi",
]);

export function isRtlLang(lang?: string | null): boolean {
  if (!lang) {
    return false;
  }
  return RTL_LANGS.has(lang.toLowerCase().split(/[-_]/)[0]);
}
